import { UserInfo } from "@customTypes/tenant/user";
import { useContext, createContext } from "react";

export const UserInfoContext = createContext<UserInfo>({});

export const useUserInfo = () => useContext(UserInfoContext);

export const UserInfoProvider = UserInfoContext.Provider;
